import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getTypeFieldAction } from "../../Actions/TypeFieldAction/TypeFieldAction";

import { FaEdit } from "react-icons/fa";
import { RiDropdownList } from "react-icons/ri";
import UpdateTypeFieldModal from "../../Modal/TypeFieldModal/UpdateTypeFieldModal";
import TypeFieldDropdownModal from "../../Modal/TypeFieldModal/TypeFieldDropdownModal";
import { FaEye } from "react-icons/fa6";

const TypeFieldPage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const getTypeField = useSelector((state) => state.getTypeField);
  const { typeFields } = getTypeField;

  useEffect(() => {
    dispatch(getTypeFieldAction(id));
  }, []);
  const navigate = useNavigate();
  const [typeFieldId, setTypeFieldId] = useState(null);
  const [isOpenDropdwonValue, setIsOpenDropdownModal] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  return (
    <div className="w-11/12 m-auto bg-white mt-2">
      <div className="parent-table">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Label</th>
              <th>Place Holder</th>
              <th>Type</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {typeFields?.map((type, index) => {
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{type.name}</td>
                  <td>{type.label}</td>
                  <td>{type.placeholder}</td>
                  <td>{type.type}</td>
                  <td>
                    <div className="flex gap-2 items-center  justify-center">
                      <button
                        onClick={() => {
                          setIsOpenModal(true);
                          setTypeFieldId(type.id);
                        }}
                        className="btn-primary flex gap-2 items-center"
                      >
                        Edit <FaEdit />
                      </button>
                      {type.type == "dropdown" && (
                        <button
                          onClick={() => {
                            setIsOpenDropdownModal(true);
                            setTypeFieldId(type.id);
                          }}
                          className="btn-warning flex gap-2 items-center"
                        >
                          Add Dropdown <RiDropdownList />
                        </button>
                      )}

                      {type.type == "dropdown" && (
                        <button
                          onClick={() => {
                            navigate("/type/field/dropdown/" + type.id);
                          }}
                          className="btn-info flex gap-2 items-center"
                        >
                          View Dropdown <FaEye />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {isOpenModal && (
        <UpdateTypeFieldModal
          id={typeFieldId}
          closeModal={() => setIsOpenModal(false)}
        />
      )}

      {isOpenDropdwonValue && (
        <TypeFieldDropdownModal
          closeModal={() => setIsOpenDropdownModal(false)}
          typeFieldId={typeFieldId}
        />
      )}
    </div>
  );
};

export default TypeFieldPage;
